import gsap from 'gsap/dist/gsap';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';

import { Hamburger } from 'components/hamburger/Hamburger';
import { HomeButton } from 'components/homeButton/HomeButton';
import { StickyScrollMenu } from 'components/stickyScrollMenu/StickyScrollMenu';
import { isMobileWidth } from 'utils/helpers';
import { GlobalDataType } from 'utils/parsers';
import { Menu } from './Menu';
import style from './MainNav.module.scss';


import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

Modal.setAppElement('#__next');

export const MainNav = (props: GlobalDataType): JSX.Element => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [lastScroll, setLastScroll] = useState<number>(0);
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      setLastScroll(0);
      closeModal();
    };

    router.events.on('routeChangeStart', handleRouteChange);

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, []);
  useEffect(() => {
    const onScroll = () => {
      // js-sticky-home-button
      const isHome = router.asPath === '/';
      const isOnPhone = isMobileWidth(window.innerWidth);
      if (isOnPhone) return;

      if (isHome && window.scrollY < window.innerHeight * 1.2) {
        gsap.to('.js-sticky-home-button', { autoAlpha: 0, duration: 0.1 });
      } else {
        gsap.to('.js-sticky-home-button', { autoAlpha: 1 });
      }
    };

    document.addEventListener('scroll', onScroll);

    return () => {
      document.addEventListener('scroll', onScroll);
    };
  }, [router.asPath]);

  const closeModal = () => {
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen(!modalIsOpen);
  };

  const onModalOpen = () => {
    setLastScroll(window.scrollY);
  };

  const onShowComplete = () => {
    document.body.classList.add('u-no-body-scroll');
  };

  const onHide = () => {
    document.body.classList.remove('u-no-body-scroll');
    gsap.to(window, { duration: 0, scrollTo: lastScroll });
  };
  const onModalClose = () => {
    // window.scrollTo(0, lastScroll);
  };
  const customStyles = {
    content: {
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      // right: '0',
      // bottom: '0',
      marginRight: '0',
      padding: 0,
      border: 0,
      borderRadius: 0,
      backgroundColor: 'rgba(0,0,0,0)',
      zIndex: 100,
    },
  };
  const isHome = router.asPath === '/';
  const logoColour = modalIsOpen ? style.logoIsWhite : null;
  return (
    <>
      <StickyScrollMenu>
        <div className={style.stickyScrollContainer}>
          <div className={style.stickyScrollToggleContainer}>
            <Hamburger onClick={toggleMenu} isOpen={modalIsOpen} />
          </div>
          <div className={`${style.stickyScrollLogoContainer} ${style.logoContainerShow} `}>
            <div className={`${style.stickyLogo} js-sticky-home-button`}>
              <HomeButton isHome={isHome} />
            </div>
          </div>
        </div>
      </StickyScrollMenu>
      <div className={style.container}>
        <div className={style.toggleContainer}>
          <Hamburger onClick={toggleMenu} isOpen={modalIsOpen} />
        </div>
        <div className={`${style.logoContainer} ${style.logoContainerShow} ${logoColour}`}>
          <HomeButton isHome={isHome} />
        </div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Menu overlay"
          shouldCloseOnOverlayClick={false}
          onAfterOpen={onModalOpen}
          onAfterClose={onModalClose}
          overlayClassName={style.overlay}
          closeTimeoutMS={750}
        >
          <Menu
            isOpen={modalIsOpen}
            closeTimeoutMS={750}
            onShowComplete={onShowComplete}
            resetScroll={onHide}
            globalData={props}
          />
        </Modal>
      </div>
    </>
  );
};
